var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated fadeInDown faster","leave-active-class":"animated fadeOutUp faster"}},[(_vm.active)?_c('interaction-feedback-alert',{attrs:{"content":_vm.content,"opt-container-content":_vm.containerContent,"interaction":_vm.content.interaction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }